export const setInterval = (ms, callback, {signal} = {}) => {
    if (signal?.aborted) {
        throw signal.reason
    }

    let id
    const stop = () => window.clearTimeout(id)
    id = window.setInterval(() => callback(stop), ms)

    if (signal) {
        signal.addEventListener('abort', stop)
    }

    return stop
}

export const setImmediate = (ms, callback, options) => {
    const stop = setInterval(ms, callback, options)
    callback(stop)
    return stop
}

export const setTimeout = (ms, {signal} = {}) => {
    if (signal?.aborted) {
        throw signal.reason
    }

    const {promise, reject, resolve} = Promise.withResolvers()
    window.setTimeout(resolve, ms)

    if (signal) {
        signal.addEventListener('abort', () => reject(signal.reason))
    }

    return promise
}
